const appConfig = {
    appId: "developerQore-e6fc2517-25e1-4bbc-b13a-417a816e170b",
    appName: "Developer",
    site: 'developer-qore',
    icon: "https://nsdstaticasset.blob.core.windows.net/assets/Qore_Brand_Icons/developeQoreAppIcon.png"
};

export default appConfig;
